import { DishPreference, DishTag } from "ts-packages/api-types/src";

import { Stack, Typography, useTheme } from "@mui/material";

import { CheckCircleRounded } from "@mui/icons-material";

import { PreferenceChipOutlined, TagChip } from "igfd-ui/src";

interface PreferenceDetectedProps {
  preference?: DishPreference | null;
  tags?: DishTag[];
}

export const PreferenceDetected = ({
  preference,
  tags,
}: PreferenceDetectedProps) => {
  const {
    palette: { oscar },
  } = useTheme();

  if (!preference && !tags?.length) {
    return null;
  }

  return (
    <Stack
      sx={{
        backgroundColor: oscar.light.surface.neutral,
        borderRadius: 4,
        gap: 1,
        padding: 3,
        width: "100%",
      }}
    >
      <Stack alignItems="center" direction="row" gap={1}>
        <CheckCircleRounded
          sx={({ palette }) => ({ color: palette.success.light })}
        />
        <Typography variant="labelLMedium">Preferences detected</Typography>
      </Stack>

      {preference ? (
        <Stack alignItems="flex-start">
          <PreferenceChipOutlined preferenceName={preference.preferenceName} />
        </Stack>
      ) : null}
      {tags?.length ? (
        <Stack alignItems="flex-start">
          {tags?.map((tag) => (
            <TagChip key={tag.id} tag={tag} />
          ))}
        </Stack>
      ) : null}
    </Stack>
  );
};
